import { FC } from "react";
import { Carousel } from "../interactives";
import Table from "./Table";

interface PlanTableGroupProps {
  planTables: any[];
  additionLabel?: boolean;
  multiPrice?: boolean;
  onlyChild?: boolean;
}

const PlanTableGroup: FC<PlanTableGroupProps> = ({ planTables, additionLabel = false, multiPrice = false, onlyChild = false }) => (
  <Carousel>
    {planTables.map(table => (
      <div role="listitem" key={table.headers[0].value} tabIndex={-1} className="focus:ring-0">
        <Table data={table} additionLabel={additionLabel} multiPrice={multiPrice} onlyChild={onlyChild} />
      </div>
    ))}
  </Carousel>
);

export default PlanTableGroup;
